import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';
import { useCanvaService } from '../services/canvaService';
import { ConnectToCanvaButton } from './ConnectToCanvaButton';

interface CanvaPortalProps {
  skipFetching?: boolean;
  isCanvaConnected?: boolean;
}

export const CanvaPortalLinks: FC<CanvaPortalProps> = props => {
  const { isCanvaConnected } = props;
  const [isConnected, setIsConnected] = useState<boolean>(!!isCanvaConnected);
  const { loading, getDesigns, disconnectFromCanva: disconnect } = useCanvaService();

  const disconnectFromCanva = useCallback(async () => {
    try {
      await disconnect();
      setIsConnected(false);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const fetchDesigns = async () => {
    const designs = await getDesigns();
    setIsConnected(!!designs?.items);
  };

  const fetchWithDelay = () => {
    window.setTimeout(async () => {
      fetchDesigns();
    }, 100);
  };

  useEffect(() => {
    window.addEventListener('focus', fetchWithDelay);
    fetchDesigns();

    return () => {
      window.removeEventListener('focus', fetchWithDelay);
    };
  }, []);

  if (isConnected) {
    return (
      <Button
        onClick={disconnectFromCanva}
        variant="outlined"
        size="small"
        sx={{minWidth: '200px'}}
        disabled={loading.getDesigns}
        fullWidth
      >
        <Typography variant="button">Disconnect Canva</Typography>
      </Button>
    );
  }

  return <ConnectToCanvaButton disabled={loading.getDesigns} />;
};
